import { Accordion, Space } from '@sravni/react-design-system';

import { OFFER_STATUS } from 'constants/offer';

import { useCrossPopup } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';
import { Map } from 'shared/ui/Map/Map';
import type { INoteProps } from 'shared/ui/Note/Note';
import { OfferPopupFeature } from 'shared/ui/OfferPopupFeature/OfferPopupFeature';

import { useOfferDetailsData } from '../../lib/useOfferDetailsData';

import styles from './OfferDetailsPopup.module.scss';

interface IOfferDetailsPopup {
  offer: TOffer;
  onClose: () => void;
  location: ILocationV2;
  note: INoteProps | null;
  controls?: JSX.Element[] | null;
}

const ACTIVE_ACCORDION_INDEX = 0;

export const OfferDetailsPopup = ({ offer, onClose, location, note, controls }: IOfferDetailsPopup) => {
  const Popup = useCrossPopup();
  const { mapItems, badges, whatsNext, summary, requirementsAndDocs, conditions, bankIcon } = useOfferDetailsData(
    offer,
    location,
  );

  return (
    <Popup
      visible
      onClose={onClose}
      className={styles.popup}
    >
      <Popup.Header
        icon={bankIcon}
        title={offer.bankName}
        subtitle={offer.productName}
      />
      <Popup.Content>
        <Space
          direction="vertical"
          size={24}
        >
          <Space
            size={16}
            direction="vertical"
          >
            <Space
              size={4}
              wrap
              data-qa="OfferDetailsPopupBadges"
            >
              {badges}
            </Space>
            <Space
              size={16}
              wrap
              direction="vertical"
            >
              {note && (
                <OfferPopupFeature
                  color="blue"
                  className={styles.note}
                  label={note.title}
                  value={note.description}
                />
              )}
              <Space
                wrap
                size={16}
                className={styles.summaries}
              >
                {summary}
              </Space>
            </Space>
          </Space>
          <Space
            size={16}
            direction="vertical"
          >
            {whatsNext}
          </Space>
          <Accordion defaultIndex={[ACTIVE_ACCORDION_INDEX]}>
            <Accordion.Item title={`Отделения ${location.nameLocative}`}>
              <Map
                coordinates={mapItems.coordinates}
                center={mapItems.center}
              />
            </Accordion.Item>
            <Accordion.Item title="Условия кредита">{conditions}</Accordion.Item>
            <Accordion.Item title="Требования и документы">{requirementsAndDocs}</Accordion.Item>
          </Accordion>
        </Space>
      </Popup.Content>
      {offer.status === OFFER_STATUS.NEW && (
        <Popup.Footer>
          <Space
            justify="end"
            className={styles.controlsContainer}
          >
            {controls}
          </Space>
        </Popup.Footer>
      )}
    </Popup>
  );
};
